// extracted by mini-css-extract-plugin
export default {"businessInfoCard":"UserCards_businessInfoCard__fvEMe","businessNumbers":"UserCards_businessNumbers__abkM6","logoCard":"UserCards_logoCard__z2xt3"};